import React from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import StatusDot from 'Components/UI/StatusDot';
import { FDStack } from '@facet-wealth/design';
import { FACET_COLORS } from 'Theme';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import LinkItem from 'Components/UI/Navigation/Item/Link';


const styles = theme => ({
  root: {},
  listItem: {
    marginLeft: 30, // To line up with the other nav list items. Spacing doesn't match
    paddingTop: theme.spacing(1),
  },
});
const ModelUpdateRequestItem = ({ classes, ...rest }) => {
  const { agentResource, isLeadPlanner } = useUserContext();
  const [count, setCount] = React.useState(0);

  const getCount = async () => {
    // Only show the badge for LPs
    if (!isLeadPlanner) return;

    const countCollection = await agentResource?.relationship(fr.relationships.managedAccountModelUpdateRequestsCount.name)?.link('related').get();
    if (!countCollection) return;
    if (countCollection.resources().length() === 0) return;
    const countResource = countCollection.resources().last();
    setCount(parseInt(countResource?.attr('count'), 10));
  };
  React.useEffect(() => {
    getCount();
  }, [agentResource]);

  const labelComponent = (
    <div>
      <FDStack direction={'row'} alignItems="flex-start" justifyContent="flex-start">
        <Typography variant={'h6'}>{'Model Update Request'}</Typography>
        {count > 0 ? <StatusDot color={FACET_COLORS.alertRed.color} size={8} /> : null}
      </FDStack>
    </div>
  );

  return (
    <LinkItem
      {...rest}
      label={labelComponent}
    />
  );
};

ModelUpdateRequestItem.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModelUpdateRequestItem);
